const topics = {};

function subscribe(topic, callback) {
  topics[topic] = topics[topic] || [];
  topics[topic].push(callback);
}

function publish(topic, argsArray) {
  topics[topic].forEach((callback) => {
    callback(...argsArray);
  });
}

export default {
  publish,
  subscribe,
};



// WEBPACK FOOTER //
// ./src/js/pubsub.js